const ALL_CONST = {
  welcome: "Welcome to Viamagus' Kaiju React Boilerplate!",
  message: " Hello!! This is Home - VIEW-1!",
  // Auth
  "label.auth.email": "Email",
  "label.auth.email_placeholder": "Enter your email",
  "label.auth.password": "Password",
  "label.auth.password_placeholder": "Enter your password",
  "label.auth.login": "Login",
  "label.auth.register": "Register",
  "label.auth.forgot_password": "Forgot Password",
  "label.auth.reset_password": "Reset Password",
  "label.auth.create_account": "Create Account",
  "label.auth.sign_in": "Sign In",
  "label.auth.sign_up": "Sign Up",
  "label.auth.sign_out": "Sign Out",
  "label.auth.sign_in_with": "Sign In With",
  "label.auth.sign_up_with": "Sign Up With",
  "label.auth.sign_in_with_google": "Sign In With Google",
  "label.auth.sign_in_with_facebook": "Sign In With Facebook",
  "label.auth.otp": "OTP",
  "label.auth.otp_placeholder": "Enter your OTP",
  "label.auth.new_password": "New Password",
  "label.auth.new_password_placeholder": "Enter your new password",
  "label.auth.username": "Username",
  "label.auth.username_placeholder": "Enter your username",
  "label.auth.first_name": "First Name",
  "label.auth.first_name_placeholder": "Enter your first name",
  "label.auth.middle_name": "Middle Name",
  "label.auth.middle_name_placeholder": "(optional)",
  "label.auth.last_name": "Last Name",
  "label.auth.last_name_placeholder": "(optional)",
  "label.auth.designation": "Designation",
  "label.auth.designation_placeholder": "eg. Developer",
  "label.auth.password_confirmation": "Password Confirmation",
  "label.auth.password_confirmation_placeholder": "Enter your password confirmation",
  "label.auth.create_password_placeholder": "Create a password",

  // common
  "label.text.synthiaAI": "Synthia AI",
  "label.text.new_chat": "New Chat",
  "label.text.synthiaAIWorkflow": "Synthia AI Workflow",
  "label.text.greetingMessage": "Lets get going!",
  "label.text.askSynthiaAnything": "Ask Synthia anything",
  "label.text.welcome_back": "Welcome Back",
  "label.text.login_to_continue": "Login to continue your AI journey",
  "label.text.login": "Login",
  "label.text.login_with_auth_0": "Login with Auth0",
  "label.text.login_with_okta": "Login with Okta",
  "label.text.login_with_azure_ad": "Login with Microsoft",
  "label.text.login_with_ping_id": "Login with Ping ID",
  "label.text.login_with_google": "Login with Google",
  "label.text.powered_by": "Powered by",
  "label.text.forgot_password": "Forgot Password?",
  "label.text.sign_up": "Sign Up",
  "label.text.create_your_account": "Create your account",
  "label.text.sign_up_to_get_started": "Sign up to get started",
  "label.text.create_account": "Create account",
  "label.text.already_have_an_account": "Already have an account? Login",
  "label.text.reset_password": "Reset Password",
  "label.text.enter_otp_and_create_new_password":
    "Enter the OTP sent to your email and create a new password.",
  "label.text.enter_email_and_send_otp":
    "Enter your email address and we'll send you a verification code to reset your password.",
  "label.text.send_otp": "Send OTP",
  "label.text.back_to_login": "Back to Login",
  "label.text.resend_available_in": "Resend available in {{count}}s",
  "label.text.resend_otp": "Resend OTP",
  "label.text.back_to_synthia_chat": "Back to Synthia Chat",
  "label.text.stop": "Stop",
  "label.text.send": "Send",
  "label.text.verify": "Verify",
  "label.text.home": "Home",
  "label.text.welcome_to_synthia_ai_message":
    "Welcome to Synthia AI, your AI-powered workspace. Explore our suite of applications designed to streamline your workflows and enhance productivity. Select an app to get started.",
  "label.text.applications": "Applications",
  "label.text.jobs": "Jobs",
  "label.text.applications_and_jobs": "Applications & Jobs",
  "label.text.launch": "Launch",
  "label.text.explore_or_search_apps": "Explore or search for apps within Synthia",
  "placeholder.text.search_jobs_and_applications": "Search for a Job or Application",
  "placeholder.text.search_jobs": "Search jobs",
  "label.text.launch_jobs": "Launch jobs",
};

export default ALL_CONST;
